import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import ImportedLogs from "./ImportedLogs";
import NotImportedLogs from "./NotImportedLogs";
import BackButton from "../../../components/Form/BackButton";

const ProjectImportLogs = () => {
  const tabsKey = {
    imported: 1,
    "not-imported": 2,
  };
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const selectedTab = query.get("tab") || "imported";
  const defaultActiveKey = tabsKey[selectedTab];
  const [activeTab, setActiveTab] = useState(
    parseInt(defaultActiveKey) === 1 ? "Imported" : "Not Imported"
  );

  const builderIdQuery = query.get("builder_id") || location?.state?.builderId;

  const builderId = localStorage?.getItem("builderId") ? localStorage?.getItem("builderId") : builderIdQuery;
  return (
    <>
      <div className="cms-page">
        <div className="page-content-block">
          <div className="full-content-block">
            <h1 className="page-title">
              <BackButton />
              Project Import Logs
            </h1>
            <div className="content-details">
              <div className="table-top-btn">
                <ul
                  className="nav nav-tabs"
                  onClick={(event) => {
                    setActiveTab(event?.target?.innerText);
                  }}
                >
                  <li className={activeTab === "Imported" ? "active" : ""}>
                    <Link key={1}>Imported</Link>
                  </li>
                  <li className={activeTab === "Not Imported" ? "active" : ""}>
                    <Link key={2}>Not Imported</Link>
                  </li>
                </ul>
              </div>
              <div className="custom-table tab-table">
                {activeTab === "Imported" && (
                  <ImportedLogs builderId={builderId} />
                )}
                {activeTab === "Not Imported" && (
                  <NotImportedLogs builderId={builderId} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectImportLogs;
